<template>
  <div>
    <!-- 修改用户信息 -->
    <i-modal :value="showModal" width="40%" class-name="vertical-center-modal" @on-cancel="cancel">
      <div slot="header" class="title">
        <h2>修改频道信息</h2>
      </div>
      <div style="text-align: center" class="modifyRole">
        <i-row style="margin: 15px 0 30px 0">
          <i-col span="5">
            <span class="title">名称：</span>
          </i-col>
          <i-col span="15">
            <i-input class="fontsize" v-model="updateName"></i-input>
          </i-col>
        </i-row>
        <i-row style="margin: 15px 0 30px 0">
          <i-col span="5">
            <span class="title">简介：</span>
          </i-col>
          <i-col span="15">
            <i-input class="fontsize" v-model="desc"></i-input>
          </i-col>
        </i-row>
        <i-row class="a-row">
          <i-col span="5">
            <span class="title">频道属性:</span>
          </i-col>
          <i-col span="15">
            <i-select v-model="updateChannelAttr" @on-change="channelAttrChange" multiple class="tmp-select">
              <i-option v-for="(item, index) in attrList" :value="item.id" :label="item.name" :key="index">
                {{ item.name }}
              </i-option>
            </i-select>
          </i-col>
        </i-row>
        <div v-for="(item, index) in updateChannelAttr" :key="index">
          <i-row class="a-row" align="middle" v-if="attrMapping[item].type.split('__')[1] === 'string'">
            <i-col span="5">
              <span class="text">{{ attrMapping[item].name }}：</span>
            </i-col>
            <i-col span="15">
              <i-input class="col-input" type="text" v-model="channelAttrData[attrMapping[item].type]"></i-input>
            </i-col>
          </i-row>
          <i-row class="a-row" align="middle" v-if="attrMapping[item].type.split('__')[1] === 'textarea'">
            <i-col span="5">
              <span class="text">{{ attrMapping[item].name }}：</span>
            </i-col>
            <i-col span="15">
              <i-input
                class="col-input"
                type="textarea"
                :rows="4"
                v-model="channelAttrData[attrMapping[item].type]"
              ></i-input>
            </i-col>
          </i-row>
          <i-row class="a-row" align="middle" v-else-if="attrMapping[item].type.split('__')[1] === 'file'">
            <i-col span="5">
              <span class="text">{{ attrMapping[item].name }}：</span>
            </i-col>
            <i-col span="15">
              <input
                v-if="attrMapping[item].type.split('__')[2] === 'picture'"
                type="file"
                accept="image/*"
                @change="
                  uploadFile($event, attrMapping[item].type.split('__')[2], attrMapping[item].type, channelAttrData)
                "
                :id="attrMapping[item].type"
              />
              <input
                v-if="attrMapping[item].type.split('__')[2] === 'video'"
                type="file"
                accept="video/*"
                @change="
                  uploadFile($event, attrMapping[item].type.split('__')[2], attrMapping[item].type, channelAttrData)
                "
                :id="attrMapping[item].type"
              />
              <input
                v-if="attrMapping[item].type.split('__')[2] === 'pdf'"
                type="file"
                accept=".pdf"
                @change="
                  uploadFile($event, attrMapping[item].type.split('__')[2], attrMapping[item].type, channelAttrData)
                "
                :id="attrMapping[item].type"
              />
            </i-col>
          </i-row>
          <i-row class="a-row" align="middle" v-if="attrMapping[item].type.split('__')[1].indexOf('enum') !== -1">
            <i-col span="5">
              <span class="text">{{ attrMapping[item].name }}：</span>
            </i-col>
            <i-col span="15">
              <i-select v-model="channelAttrData[attrMapping[item].type]" filterable>
                <i-option v-for="(_item, index) in attrMapping[item].value" :value="_item" :key="index">
                  {{ _item }}
                </i-option>
              </i-select>
            </i-col>
          </i-row>
        </div>
        <i-row class="a-row">
          <i-col span="5">
            <span class="title">属性:</span>
          </i-col>
          <i-col span="15">
            <i-select v-model="updateAttr" multiple class="tmp-select">
              <i-option v-for="(item, index) in attrList" :value="item.id" :label="item.name" :key="index">
                {{ item.name }}
              </i-option>
            </i-select>
          </i-col>
        </i-row>
        <i-row style="margin:15px 0 30px 0">
          <i-col span="5">
            <span class="title">可用模板:</span>
          </i-col>
          <i-col span="15">
            <i-select v-model="updateTmp" multiple class="tmp-select">
              <i-option v-for="(item, index) in templateData" :value="item.id" :key="index">{{ item.name }}</i-option>
            </i-select>
          </i-col>
        </i-row>
      </div>
      <div slot="footer" style="text-align: center">
        <i-button type="primary" size="large" style="width: 200px" @click="submitUpdate">确认</i-button>
      </div>
    </i-modal>
  </div>
</template>

<script>
import { baseConfigMixin, uploadFileMixin } from "../mixin"

export default {
  data() {
    return {
      templateData: [],
      updateName: "",
      updateDesc: "",
      updateTmp: [],
      attrList: [],
      updateAttr: [],
      updateChannelAttr: [],
      attrMapping: {},
      channelAttr: {},
      imageLoading: false,
      channelMap: {},
      channelAttrData: {}, //存放所有的属性
    }
  },
  mixins: [baseConfigMixin, uploadFileMixin],
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    englishName: {
      type: String,
      default: "",
    },
    desc: {
      type: String,
      default: "",
    },
    tmp: {
      type: Array,
      default() {
        return []
      },
    },
    attr: {
      type: Array,
      default() {
        return []
      },
    },
    initChannelAttr: {
      type: Array,
      default() {
        return []
      },
    },
    initChannelAttrData: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  methods: {
    cancel() {
      this.$emit("cancelModal")
    },
    channelAttrChange() {
      let initChannelAttr = {}
      const self = this
      this.updateChannelAttr.forEach((item) => {
        if (self.attrMapping[item].type.indexOf("cms__file") === -1) {
          initChannelAttr[self.attrMapping[item].type] = ""
        }
      })
      Object.keys(this.channelAttrData).forEach((item) => {
        if (Object.keys(initChannelAttr).indexOf(item) !== -1) {
          if (item.indexOf("cms__file") === -1) {
            initChannelAttr[item] = self.channelAttrData[item]
          }
        }
      })
      self.channelAttrData = initChannelAttr
    },
    async submitUpdate() {
      if (this.updateName === "") {
        this.$Message.error("频道名称不能为空")
        return
      }
      if (this.imageLoading) {
        this.$Message.error("请等待文件上传完成！")
        return
      }
      for (let item in this.channelAttr) {
        if (this.channelAttr[item] === "") {
          this.$Message.error("请填写" + this.channelMap[item] + "!")
          return
        }
      }
      const res = await this.axios({
        method: "post",
        url: this.cmsUrl + "api/content/channel/edit",
        data: {
          cid: this.id,
          name: this.updateName,
          channel_attributes: this.updateChannelAttr,
          channel_attr_data: Object.keys(this.channelAttrData).length > 0 ? this.channelAttrData : null,
          desc: this.updateDesc,
          attributes: this.updateAttr,
          templates: this.updateTmp,
        },
      })
      if (!res) {
        return
      }
      if (res.data.code === 0) {
        this.$Message.success("修改成功")
        this.$emit("success")
        this.cancel()
      } else {
        this.showLoading = false
        this.$Message.error("操作失败，错误原因：" + res.data.error_message)
      }
    },
    //获取模板信息
    async getTemplate() {
      let self = this
      self.showLoading = true
      try {
        const res = await self.axios({
          method: "get",
          url: this.cmsUrl + "api/content/template/list",
        })
        if (!res) {
          return
        }
        if (res.data.code === 0) {
          self.showLoading = false
          this.templateData = res.data.data.data
        } else {
          self.showLoading = false
          self.$Message.error("获取模板操作失败，错误原因：" + res.data.error_message)
          console.log(res)
        }
      } catch (err) {
        self.showLoading = false
        self.$Message.error("操作失败，错误原因：" + err)
        console.log(err)
      }
    },
    //获取属性信息
    async getAttr() {
      let self = this
      self.showLoading = true
      try {
        const res = await self.axios({
          method: "get",
          url: this.cmsUrl + "api/content/attribute/list",
        })
        if (!res) {
          return
        }
        if (res.data.code === 0) {
          self.showLoading = false
          this.attrList = []
          this.attrList.push(...res.data.data.data)
          res.data.data.data.forEach((item) => {
            self.attrMapping[item.id] = item
            self.channelMap[item.type] = item.name
            self.channelAttrData[item.type] = ""
          })
        } else {
          self.showLoading = false
          self.$Message.error("获取模板操作失败，错误原因：" + res.data.error_message)
          console.log(res)
        }
      } catch (err) {
        self.showLoading = false
        self.$Message.error("操作失败，错误原因：" + err)
        console.log(err)
      }
    },
  },
  async mounted() {
    await this.getTemplate()
    await this.getAttr()
  },
  watch: {
    showModal() {
      if (this.showModal) {
        this.updateName = this.name
        this.updateDesc = this.desc
        this.updateTmp = []
        for (let i = 0; i < this.tmp.length; i++) {
          this.updateTmp.push(this.tmp[i]._id.$oid)
        }
        this.updateAttr = []
        for (let i = 0; i < this.attr.length; i++) {
          this.updateAttr.push(this.attr[i]._id.$oid)
        }
        for (let i = 0; i < this.initChannelAttr.length; i++) {
          this.updateChannelAttr.push(this.initChannelAttr[i].id)
        }
        this.channelAttrData = JSON.parse(JSON.stringify(this.initChannelAttrData))
      } else {
        this.updateName = ""
        this.updateDesc = ""
        this.updateTmp = []
        this.updateAttr = []
        this.updateChannelAttr = []
        this.channelAttr = {}
        this.channelAttrData = {}
      }
    },
  },
}
</script>

<style scoped>
.title {
  text-align: center;
}
.tmp-select {
  text-align: left;
  min-width: 200px;
}
</style>
